import type { ReactNode } from "react";

type Props = {
  eyebrow?: string;
  title: ReactNode;
  intro?: ReactNode;
  align?: "left" | "center";
  as?: "h1" | "h2";
};

export function SectionHeading({ eyebrow, title, intro, align = "left", as = "h2" }: Props) {
  const a = align === "center" ? "text-center mx-auto" : "";
  const Heading = as;
  return (
    <div className={`max-w-3xl ${a}`}>
      {eyebrow && (
        <div className="inline-flex items-center gap-2 rounded-full border border-border px-3 py-1 text-[0.7rem] uppercase tracking-[0.18em] text-muted-foreground">
          <span className="h-1 w-1 rounded-full bg-primary" />
          {eyebrow}
        </div>
      )}
      <Heading className="mt-4 text-balance font-display text-3xl leading-[1.05] md:text-5xl">
        {title}
      </Heading>
      {intro && (
        <p className="mt-5 text-base md:text-lg text-muted-foreground max-w-2xl">
          {intro}
        </p>
      )}
    </div>
  );
}

